import { CalloutInputs } from './Callout';

export const calloutTransformer = (node, isPolicy?: boolean): CalloutInputs => {
    const cta = [];

    // cta field is either an array (CEW) or object (GA), deal with it
    if (isPolicy) {
        cta.push(...node.field_cta_link);
    } else if (node.field_cta_link?.length) {
        cta.push(...node.field_cta_link);
    }

    return {
        calloutImage: {
            gatsbyImage:
                node.relationships?.field_callout_image?.relationships
                    ?.field_media_image?.localFile,
            alt: node.relationships?.field_callout_image?.field_media_image
                ?.alt,
        },
        bgColor: node.field_background_color,
        imagePosition: node.field_image_position,
        eyebrowText: node.field_eyebrow_text,
        title: node.field_component_title,
        textContent: node.field_text_content?.value,
        cta: cta.map((link) => ({
            uri: link.uri,
            title: link.title,
        })),
    };
};
